import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = {
  for: "name",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = {
  for: "email",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = ["readonly"]
const _hoisted_10 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_11 = {
  for: "appId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = {
  for: "is_blocked",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_15 = { class: "col-sm-8" }
const _hoisted_16 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_17 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_18 = {
  for: "isManualWithdrawals",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_19 = { class: "col-sm-8" }
const _hoisted_20 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_21 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_22 = {
  for: "createInvite",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_23 = { class: "col-sm-8" }
const _hoisted_24 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_25 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_26 = {
  for: "password",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_27 = { class: "col-sm-8" }
const _hoisted_28 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_29 = {
  for: "permissions",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_30 = { class: "col-sm-8" }
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "form-check small mb-0" }
const _hoisted_33 = ["value", "id"]
const _hoisted_34 = ["for"]
const _hoisted_35 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_36 = {
  for: "merchantId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_37 = { class: "col-sm-8" }
const _hoisted_38 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_39 = {
  for: "2fa",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_40 = { class: "col-sm-8 align-items-center d-flex" }
const _hoisted_41 = {
  key: 0,
  class: "text-success"
}
const _hoisted_42 = {
  key: 1,
  class: "text-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.name")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`name`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  id: "name"
                }, null, 2), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.email")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`email`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  readonly: !!_ctx.form.id,
                  type: "text",
                  id: "email"
                }, null, 10, _hoisted_9), [
                  [_vModelText, _ctx.form.email]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        (!_ctx.merchantFixed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.domain")), 1),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`appId`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "referralId",
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.appId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.appId) = $event)),
                      options: _ctx.store.getters['getAppsIds'],
                      "custom-label": (opt) => _ctx.store.getters['getAppById'](opt)?.domain,
                      "select-label": "Select",
                      placeholder: "",
                      "open-direction": "bottom",
                      multiple: false,
                      searchable: true,
                      "internal-search": true,
                      "clear-on-select": false,
                      "close-on-select": true,
                      "options-limit": 100,
                      limit: 1000,
                      "show-no-results": false,
                      "hide-selected": false
                    }, null, 8, ["class", "modelValue", "options", "custom-label"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.helper.trans("labels.is_blocked")), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.isBlocked) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "is_blocked"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.isBlocked]
              ])
            ])
          ])
        ]),
        (!_ctx.merchantFixed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.helper.trans("labels.isManualWithdrawals")), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.isManualWithdrawals) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    id: "isManualWithdrawals"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.isManualWithdrawals]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.form.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.helper.trans("labels.create_invite")), 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.createInvite) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    id: "createInvite"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.createInvite]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ((_ctx.form.id || _ctx.form.createInvite === false) && (_ctx.isMerchant || _ctx.store.getters.hasPermission(_ctx.UserPermission.RESET_MERCHANT_PASSWORD)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.helper.trans("labels.password")), 1),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`password`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-group", parentProps.class])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.password) = $event)),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        type: "text",
                        id: "password"
                      }, null, 2), [
                        [_vModelText, _ctx.form.password]
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.form.password = _ctx.helper.generatePassword()), ["prevent"])),
                        type: "button",
                        class: "btn btn-outline-secondary"
                      }, _cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "fa fa-rotate" }, null, -1)
                      ]))
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.userPermissionsFiltered.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.helper.trans("labels.permissions")), 1),
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userPermissionsFiltered, (permission) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        value: permission.id,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.permissions) = $event)),
                        type: "checkbox",
                        id: permission.id
                      }, null, 8, _hoisted_33), [
                        [_vModelCheckbox, _ctx.form.permissions]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: permission.id
                      }, _toDisplayString(permission.name), 9, _hoisted_34)
                    ])
                  ]))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.merchantFixed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.helper.trans("labels.merchant")), 1),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`merchantId`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "merchantId",
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.merchant,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.merchant) = $event)),
                      "track-by": "id",
                      disabled: !!_ctx.form.id,
                      options: _ctx.merchants,
                      "custom-label": (opt) => `${opt.name} (${opt.email})`,
                      "custom-value": (opt) => opt.id,
                      "select-label": "Select",
                      placeholder: "",
                      "open-direction": "bottom",
                      multiple: false,
                      searchable: true,
                      "internal-search": true,
                      "clear-on-select": false,
                      "close-on-select": true,
                      "options-limit": 100,
                      limit: 1000,
                      "show-no-results": false,
                      "hide-selected": false,
                      onSearchChange: _ctx.asyncFindMerchants,
                      loading: _ctx.isMerchantSelectLoading
                    }, null, 8, ["class", "modelValue", "disabled", "options", "custom-label", "custom-value", "onSearchChange", "loading"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.helper.trans("labels.2fa")), 1),
              _createElementVNode("div", _hoisted_40, [
                (_ctx.form?.is2faEnabled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.helper.trans('labels.enabled')), 1))
                  : _createCommentVNode("", true),
                (!_ctx.form?.is2faEnabled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.disabled')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.form?.is2faEnabled)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-danger ms-2 btn-sm text-capitalize-first",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.disable2fa(_ctx.form.id)), ["prevent"]))
                    }, _toDisplayString(_ctx.helper.trans("labels.disable")), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ConfirmModal, { ref: "twoFaConfirmModal" }, null, 512)
  ]))
}